<script setup lang="ts">
import { useCityStore } from '@/store/city/city'

import { NewProductModification } from '@/types/api/api-v4/product'
import { ProductParentType } from '@/types/components/product-card.types'

import ProductTag from '@/components/Product/ProductTags/ProductTag.vue'

type Props = {
  type: ProductParentType
  currentModification: NewProductModification
}

const props = defineProps<Props>()

const { currencySymbol } = useCityStore()

const discountValue = computed(() => {
  const { price, subprice } = props.currentModification

  const showDiscount = Number(subprice) > Number(price)

  return showDiscount ? Number((price - subprice).toFixed(2)) : 0
})
</script>

<template>
  <product-tag
    v-if="discountValue"
    color="var(--ui-text-primary)"
    background-color="var(--ui-yellow)"
    :type="type"
  >
    {{ discountValue }} {{ currencySymbol }}
  </product-tag>
</template>
